export default {
  views: {
    subGroups: {
      assign: "Alt gruplar atayın",
      tagManager: "Etiket yöneticisi: Grubunuzu seçin",
      successAssign: "Harika! Grubunuz için Alt Grupları güncellediniz.",

      errors: {
        assign: "Ah ah! Bir alt grup atanamıyor"
      },

      table: {
        firstName: "İlk adı",
        lastName: "Soyadı",
        username: "Kullanıcı adı",
        subGroup: "alt grup"
      }
    },

    classes: {
      label: "Grup",

      editGroup: "Grubu düzenle. Adım",
      addGroup: " Grup ekle. Adım",
      classesCount: "{count} grupları",

      errors: {
        group: "Grup verileri yüklenemedi.",
        update: "Grup güncellenemedi. Daha sonra tekrar deneyin",
        create: "Grup oluşturulamadı",
        emptyList: "Seçili okulda henüz grubunuz yok."
      },

      messages: {
        create: "Grup başarıyla oluşturuldu!"
      }
    },

    schools: {
      label: "Okul",

      errors: {
        emptyList: "Mevcut okulunuz yok.",
        fetchError: "Okullar getirilemedi"
      }
    },

    teachers: {
      teachersCount: "{count} öğretmenler",

      errors: {
        emptyList: "Henüz hiç öğretmeniniz yok.",
        details: " Öğretmen verileri alınamadı."
      },

      titles: {
        edit: "Öğretmeni düzenle"
      },

      messages: {
        create: "Bir öğretmen başarıyla oluşturuldu!",
        update: "Bir öğretmen güncellendi!"
      }
    },

    grammarToGo: {
      title: "Tamamlanmamış Dilbilgisi"
    },

    home: {
      wantToAssign: "Ders atamak istiyorum",
      whatStudentsDo: "Öğrencileriniz Little Bridge'de ne yapıyor?",
      howManyCountries: "Öğrencilerinizin kaç ülkede DigiPal'ı var?",
      numActivities: "Öğrencileriniz kaç aktivite yaptı?",
      numFriends: "Öğrencilerinizin kaç DigiPal'ı var?",
      numMessages: "Öğrencileriniz kaç mesaj gönderdi?",

      errors: {
        dashboard: "Kontrol paneli verileri alınamadı."
      }
    },

    knowledgeBase: {
      title: "Bilgi Bankası",

      errors: {
        fetch: "Bilgi tabanı getirilemedi",
        details: "Bilgi tabanı bilgileri alınamadı"
      }
    },

    lessons: {
      label: "Ders",

      subgroups: "Alt Gruplar",

      messages: {
        setLessonsAuto:
          "Little Bridge, öğrencilerinizin derslerini otomatik olarak planlayacaktır. Öğrenciler kendi hızlarında öğrenecekler. Öğrencilerinize bir ders atayarak bunu istediğiniz zaman geçersiz kılabilirsiniz."
      },

      hasBeenAssigned: "Bu ders atandı.",
      assignAnother: "Başka bir ders atayın",
      assignMyself: "Dersi kendim atamak istiyorum",
      assignAuto:
        "Little Bridge'in dersleri otomatik olarak atamasını istiyorum",
      lessonId: "Ders {lessonId}",
      set: "Dersi ayarlayın",
      activity: "Aktivite",
      resources: "Kaynaklar",

      statuses: {
        selected: "Ders seçildi",
        archived: "Arşivlendi",
        current: "Güncel ders",
        unassigned: "Atanmamış"
      },

      stepper: {
        titles: {
          step1: "1. Adım - Kime ders atamak istiyorsunuz?",
          step2: "2. Adım - Bir ders seçin",
          step3: "3. Adım - Onaylayın"
        }
      },

      errors: {
        fetch: "Dersler alınamadı."
      }
    },

    reports: {
      title: "Rapor Oluşturucu",
      type: "Rapor türü",
      generate: "Rapor oluştur",

      level: "Seviye raporu",
      lesson: "Ders raporu",

      test: "Checkpoint raporu",
      diagnostic: "Tanılama raporu",
      baseline: "Temel rapor",
      progress: "İlerleme testi",
      students: "öğrenciler",

      download: {
        pdf: "PDF olarak indir",
        csv: "CSV olarak indir",
        lessonPlan: "PDF olarak indir"
      },

      errors: {
        generate: "Rapor oluşturulamadı. Lütfen daha sonra tekrar deneyin."
      }
    },

    students: {
      label: "Öğrenci",
      editStudent: "Öğrenciyi Düzenle",
      stundentsCount: "{count} Öğrenci",
      add: "Öğrenci ekle",
      saveAndDownload: "Öğrenci listesini kaydedin ve indirin",
      download: "Öğrenci listesini indirin",

      import: {
        step: "adım: Öğrencileri içe aktarın - adım ",
        clickVideo: "Kısa bir eğitim videosu izlemek için burayı tıklayın",
        copyPasteFirst:
          "Lütfen öğrencilerinizin adlarını kopyalayıp 'Ad' metin kutusuna yapıştırın.Bir seferde en fazla 100 öğrenciyi içe aktarabilirsiniz.",
        copyPasteLast:
          "Lütfen öğrencilerinizin soyadlarını kopyalayıp 'Soyadı' metin kutusuna yapıştırın.",
        confirm:
          "Harika! Şimdi her şeyin doğru olup olmadığını kontrol edelim. Herhangi bir değişiklik yapmak isterseniz geri dönebilirsiniz. Lütfen her öğrencinin her iki adının da doğru şekilde eşleştiğinden emin olun.",
        thoseStudentsAdded:
          "Bu öğrenciler hesabınıza eklendi. Güvenlik nedeniyle şifreleri tekrar indiremeyeceksiniz. Lütfen sağlanan dosyayı güvenli bir konuma kaydettiğinizden emin olun. Dosya otomatik olarak indirilmediyse lütfen şimdi 'Öğrenci listesini indirin' düğmesini tıklayın.",
        note: "Not - İçe aktarma başına 100 öğrenci sınırı vardır."
      },

      messages: {
        create: "Bir öğrenci başarıyla oluşturuldu!",
        update: "Bir öğrenci güncellendi!"
      },

      errors: {
        emptyList: "Henüz öğrenciniz yok.",
        details: "Öğrenci verileri alınamadı.",
        import:
          "Eyvah! Bir sorun oluştu. Adları tekrar kopyalayıp yapıştırmayı deneyebilir misiniz?",
        importPaste: "Eyvah! sütununa hiçbir şey yapıştırmadınız."
      }
    }
  },

  stepsLabels: {
    step4: "4. Adım - Onaylayın"
  },

  common: {
    next: "Sonraki",
    ok: "tamam",
    unassigned: "Atanmamış",
    close: "Kapat",
    nextConfirm: "Sonraki adım - onaylayın",
    continue: "Devam et",
    returnHome: "Ana sayfaya dön",
    finish: "Bitir",
    confirm: "Onayla",
    save: "Kaydet",
    siteUsage: "Site kullanımı",
    reset: "Sıfırla"
  },

  errors: {
    basic: "Veriler yüklenemedi.",
    unexpected: "Beklenmedik bir hata oluştu.",
    admin: "Bunu yapma yetkiniz yok. Lütfen hesap yöneticisine başvurun."
  },

  tables: {
    lessons: {
      level: "Seviye",
      topic: "Konu",
      lesson: "Ders",
      summary: "Özet",
      content: "İçerik",
      status: "Durum",
      testCategory: "Test kategorisi"
    },

    reports: {
      firstName: "Ad",
      lastName: "Soyadı",
      username: "Kullanıcı Adı",
      lesson: "Ders",
      scoreForActivity: "Puan - {activityId}",
      correct: "Doğru",
      progress: "İlerle",
      levelNumber: "Seviye",
      lessonName: "Ders adı",
      topic: "Başlık",
      activity1: "Aktivite 1",
      activity2: "Aktivite 2",
      activity3: "Aktivite 3",
      activity4: "Aktivite 4"
    },

    classes: {
      group: "Grup",
      subgroup: "Alt grup",
      teacher: "Öğretmen",
      numberOfStudents: "Öğrenci sayısı",
      lesson: "Güncel ders",

      errors: {
        failedDelete: "Gruplar silinemedi. Daha sonra tekrar deneyin.",
        canBeAssign:
          "Öğrenciler tek seferde yalnızca bir gruba atanabilir. Bu gruba atanan tüm öğrenciler mevcut gruplarından kaldırılacaktır."
      }
    }
  },

  components: {
    noActivitiesInLesson: "Bu derste hiçbir aktivite yok.",
    selectAll: "Tümünü seç",
    groupName: "Grup adı",
    assignStudents: "Sonraki adım - öğrenci atayın",
    assignTeachers: "Sonraki adım - öğretmen atayın",
    noData: "Hiç veri yok.",
    videoSupport: "Maalesef tarayıcınız gömülü videoları desteklemiyor.",
    generateUsername: "Yeni kullanıcı adı oluştur",
    password: "Şifre",
    admin: "Yönetici",
    view: "Görünüm",
    goBack: "Geri gitmek",
    openLanguageMenu: "Dil menüsünü aç",
    isAdmin: "Yönetici",
    selectALevel: "Bir seviye seçin",

    warnings: {
      deleteClasses: "{clasessNames} sınıfı silmek üzeresiniz"
    },

    errors: {
      selectGroups: "Önce grupları seçin.",
      editOneGroupAtOnce: "Tek seferde yalnızca 1 grubu düzenleyebilirsiniz",

      selectStudents: "Önce öğrencileri seçin.",
      deleteStudents: "Kullanıcıları silmek üzeresiniz ",
      editOneStudentAtOnce:
        "Aynı anda yalnızca 1 öğrenciyi düzenleyebilirsiniz",
      failedToDeleteStudents:
        "Öğrenciler silinemedi. Daha sonra tekrar deneyin.",
      selectTeachers: "Önce öğretmenleri seçin.",
      deleteTeachers: "Öğretmenleri silmek üzeresiniz",
      editOneTeacherAtOnce:
        "Aynı anda yalnızca 1 öğretmeni düzenleyebilirsiniz",
      failedToDeleteTeachers: "Öğretmenler silinemedi. Daha sonra tekrar dene.",
      teacherNames: "Lütfen öğretmenin adını ve soyadını yazınız.",
      failedUsername:
        "Kullanıcı adı oluşturma başarısız oldu. Daha sonra tekrar deneyin.",
      teacherEdit: "Öğretmenin kullanıcı adı düzenlenemiyor"
    }
  },

  navigation: {
    subgroups: "Alt gruplar atayın",
    open: "Menüyü aç",
    goToDashboard: "Öğretmen kontrol paneline git",
    teachers: "Öğretmenler",
    students: "Öğrenciler",
    lessons: "Dersler",
    groups: "Gruplar",
    reports: "Rapor Oluşturucu",
    grammar: "Tamamlanmamış Dilbilgisi",
    knowledge: "Bilgi Bankası",
    logout: "Çıkış Yap"
  }
};
